module.exports = __webpack_public_path__ + "static/gitnext-01790502f406642e83161c60befc93f3.png";